<style lang="scss" scoped>
.sds {
	&__pad-bottom {
		margin-bottom: 30px;
	}
	&__text {
		padding: 20px;
		text-align: center;
	}
}
</style>

<template lang="pug">
.sds
	app-header
		.sds__header(slot='header')
			h1 Generate CSV for {{ providerName }} {{ settings[providerCode].name }}
	.container
		.main-panel
			loading(v-if='$apollo.loading')
			.main-panel__padding(v-else)
				p.mb-0
					el-form(label-position='top')
						el-card(v-for="v in Object.keys(settings[providerCode].csv)" :class="v=='v2.1' ? 'box-card' : 'box-card sds__pad-bottom'")
							el-form-item
								el-radio(v-model="version" :label="v" @change="changeVersion" :disabled="loading") {{ settings[providerCode].name }} {{ v }} Format
							el-form-item
								el-checkbox(label="school" border v-model="settings[providerCode].csv[v].selectAll" :disabled="settings[providerCode].csv[v].disabled" @change="csvs=settings[providerCode].csv[v].selectAll ? settings[providerCode].csv[v].data : []") Select All
							el-form-item
								el-checkbox-group(v-model="csvs" :disabled="settings[providerCode].csv[v].disabled")
									el-checkbox(v-for="selections in settings[providerCode].csv[v].data" :label="selections" border :key="selections" class="labelCheckbox") {{ selections | capitalize }}.csv
			.main-panel__footer.text-right
				el-dropdown(@command='download')
					el-button(type='success' :disabled="!version || !csvs.length" :loading="loading") Download
						i.el-icon-arrow-down.el-icon--right
					el-dropdown-menu(slot="dropdown")
						el-dropdown-item(command='new') New users
						el-dropdown-item(command='existing') Existing users
</template>

<script>
import gql from "graphql-tag";
export default {
	data() {
		return {
			version: "v1",
			csvs: [],
			settings: {
				msft: {
					name: "School Data Sync",
					csv: {
						v1: {
							data: ["school","section","student","studentEnrollment","teacher","teacherRoster"],
							selectAll: false,
							UKFormat: true,
							disabled: false,
						},
						"v2.1": {
							data: ["classes","enrollments","orgs","users", "roles"],
							selectAll: false,
							disabled: true,
						},
					}
				},
			},
			loading: false,
			category: "existing",
			updatedCache: false,
		};
	},

	apollo: {
		auth: {
			query: gql`
				{
					Auth {
						redirect_url
					}
				}
			`,
			update: r => r.Auth
		},
		form: {
			query: gql`
				{
					AdSettings {
						id
						msad_host
						msad_username
						msad_password
					}
				}
			`,
			fetchPolicy: "cache-and-network",
			update: r => {
				const data = _.cloneDeep(r.AdSettings);
				data.msad_password = null;

				return data;
			}
		},
		csv: {
			query: gql`
				query DownloadSchoolData($version: String!, $csvs: [String!]!, $format: SchoolDataFormatEnum!, $category: SchoolDataUserCategoryEnum!) {
					DownloadSchoolData(version: $version, csvs: $csvs, format: $format, category: $category) {
						content
					}
				}
			`,
			variables() {
				return {
					version: this.version,
					csvs: this.csvs,
					format: this.settings[this.providerCode].csv[this.version].UKFormat ? "uk" : "standard",
					category: this.category,
				}
			},
			fetchPolicy: "network-only",
			update(r) {
				if(r.DownloadSchoolData && !_.isEmpty(r.DownloadSchoolData.content)) {
					this.loading = false;
				}
				return _.cloneDeep(r.DownloadSchoolData)
			},
			pollInterval: 5000,
			fetchPolicy: "no-cache",
			skip() {
				return !this.loading || !this.updatedCache;
			},
		},
	},
	watch: {
		csvs: function (newVal) {
			this.settings[this.version].selectAll = newVal.length === this.settings[this.version].data.length || false
		},
		csv(val) {
			if (val && val.content) {
				const linkSource = `data:application/zip;base64,${val.content}`;
				let downloadLink = document.createElement("a");
				downloadLink.href = linkSource;
				downloadLink.download = `${this.settings[this.providerCode].name} ${this.version}.zip`;
				downloadLink.click();
			}
		}
	},
	methods: {
		async download(category) {
			this.loading = true;
			this.csv = null;
			this.category = category;
			this.updatedCache = false;
			await this.$apollo.mutate({
				mutation: gql`
					mutation CacheClear($item: CacheTypeEnum!) {
						CacheClear(item: $item)
					}`,
					variables: {
						item: "csv"
					}
					
			});
			this.updatedCache = true;
		},
		
		changeVersion() {
			const settingsKeys = Object.keys(this.settings[this.providerCode].csv);

			settingsKeys.forEach((k) => {
				this.settings[this.providerCode].csv[k].disabled = true;
				this.settings[this.providerCode].csv[k].selectAll = false;
			});
			this.csvs = [];
			this.settings[this.providerCode].csv[this.version].disabled = false;
		} 
	}
};
</script>
